module.exports = __webpack_public_path__ + "img/home_bg.25a5ef13.png";